<template>
  <div class="page__sub_account a-page" style="padding-top: 10px">
    <div style="background-color:white; padding:10px; border-radius: 4px; overflow: hidden">
      <div style="text-align: center">
        <p><strong style="font-size: 20px">{{ $t('menu.sub_accounts') }}</strong></p>
      </div>
      <div>
        <el-row>
          <el-col :sm="4" style="padding-top: 5px">
            <p>
              <strong style="font-size: 14px" class="text-primary">{{ $t('sub_accounts.invitation_send') }}</strong>
            </p>
          </el-col>
          <el-col :sm="4" style="padding-right: 10px">
            &nbsp;
          </el-col>
          <el-col :sm="4" style="padding-right: 10px">
            &nbsp;
          </el-col>
          <el-col :sm="12" class="text-right">
            <el-input style="width: 40%" type="text" size="mini" placeholder="Nhập tài khoản Atosa..."
                      v-model="username" @keyup.enter.native="m__send_request"></el-input>
            &nbsp;&nbsp;
            <el-button size="mini" type="primary" icon="el-icon-plus" @click="m__send_request">
              {{ $t('sub_accounts.send_invitation') }}
            </el-button>
          </el-col>
        </el-row>
        <el-table :data="send_request_list">
          <el-table-column :label="$t('base.username')" prop="request_user.username"></el-table-column>
          <el-table-column :label="$t('base.receiver')" prop="request_user.display_name"></el-table-column>
          <el-table-column :label="$t('base.state')">
            <template slot-scope="scope">
              <strong v-if="scope.row.status === 'pending'" class="text-warning">
                {{ $t('base.pending_confirm') }}
              </strong>
              <strong v-if="scope.row.status === 'accepted'" class="text-success">
                {{ $t('base.confirmed') }}
              </strong>
              <strong v-if="scope.row.status === 'rejected'" class="text-danger">
                {{ $t('base.rejected') }}
              </strong>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.send_at')">
            <template slot-scope="scope">
              {{ scope.row.created_at | timeFormat }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.action')">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status !== 'rejected'" type="text" size="mini"
                         @click="m__delete_sub_account_request(scope.row._id)">
                <strong class="text-danger">{{ $t('base.rejected') }}</strong>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="margin-top: 20px" class="text-primary">
        <el-row>
          <el-col :sm="20">
            <p><strong style="font-size: 14px">{{ $t('shop.list') }}</strong></p>
          </el-col>
          <el-col :sm="4">
            <el-input size="mini" placeholder="Nhập tên shop, id..." suffix-icon="el-icon-search"
                      v-model="search_shop"></el-input>
          </el-col>
        </el-row>
        <el-table style="margin-top: 10px" :data="c__shopee_shop_filer_list">
          <el-table-column :label="$t('base.channel')" width="100px">
            <template slot-scope="scope">
              <img style="width:32px; height:32px; border-radius: 50vh;"
                   :src="logo_channel(scope.row.channel)" alt="channel_logo">
            </template>
          </el-table-column>
          <el-table-column :label="$t('shop.name')">
            <template slot-scope="scope">
              <span>{{
                  scope.row.username
                }}</span>
              <div style="font-size:10px; color:gray;">ID:
                <span>{{ scope.row.user_id || scope.row.shop_id }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.created_at')">
            <template slot-scope="scope">
              {{ scope.row.created_time | timeFormat }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('menu.sub_accounts')" show-tooltip-when-overflow>
            <template slot-scope="scope">
              <strong v-if="scope.row.request_user" class="text-primary">{{ scope.row.request_user.display_name }} -
                {{ scope.row.request_user.username }}</strong>
              <strong v-else class="text-danger">{{ $t('sub_accounts.has_no_sub_account') }}</strong>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.action')">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="m__show_add_shop_dialog(scope.row)">
                <strong v-if="scope.row.request_user" class="text-warning">{{ $t('base.update') }}</strong>
                <strong v-else class="text-primary">{{ $t('sub_accounts.select_sub_account') }}</strong>
              </el-button>

              <el-button type="text" size="mini" v-if="scope.row.request_user"
                         @click="m__delete_sub_account_shop(scope.row.sub_account_shop_id)">
                <strong class="text-danger">{{ $t('sub_accounts.delete_rule') }}</strong>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="text-align: center; margin-top: 30px">
        <p><strong style="font-size: 20px">{{ $t('sub_accounts.invitation_accounts') }}</strong></p>
      </div>
      <div class="text-warning">
        <p><strong style="font-size: 14px">{{ $t('sub_accounts.invitation_shops') }}</strong></p>
        <el-table :data="request_list">
          <el-table-column :label="$t('base.username')" prop="user.username"></el-table-column>
          <el-table-column :label="$t('sub_accounts.invitation_by')" prop="user.display_name"></el-table-column>
          <el-table-column :label="$t('base.status')">
            <template slot-scope="scope">
              <strong v-if="scope.row.status === 'pending'" class="text-warning">
                {{ $t('base.pending_confirm') }}
              </strong>
              <strong v-if="scope.row.status === 'accepted'" class="text-success">
                {{ $t('base.confirmed') }}
              </strong>
              <strong v-if="scope.row.status === 'rejected'" class="text-danger">
                {{ $t('base.rejected') }}
              </strong>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.send_at')">
            <template slot-scope="scope">
              {{ scope.row.created_at | timeFormat }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.action')">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status === 'pending'" size="mini" type="text"
                         @click="m__change_request_status(scope.row._id, 'accepted')"><strong class="text-success"><i
                class="el-icon-check"></i> {{ $t('base.accept') }}</strong></el-button>

              <el-button v-if="scope.row.status === 'pending'" size="mini" type="text"
                         @click="m__change_request_status(scope.row._id, 'rejected')"><strong class="text-danger"><i
                class="el-icon-close"></i> {{ $t('base.reject') }}</strong></el-button>
              <el-button v-if="scope.row.status === 'accepted'" type="text" size="mini"
                         @click="m__delete_sub_account_request(scope.row._id)">
                <strong class="text-danger">{{ $t('sub_accounts.cancel_invitation') }}</strong>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 20px" class="text-warning">
        <p><strong style="font-size: 14px">{{ $t('sub_accounts.managed_shops') }}</strong></p>
        <el-table :data="sub_account_shop_request_list">
          <el-table-column :label="$t('base.channel')" width="100px">
            <template slot-scope="scope">
              <img style="width:32px; height:32px; border-radius: 50vh;"
                   :src="logo_channel(scope.row.shop.channel)" alt="channel_logo">
            </template>
          </el-table-column>
          <el-table-column :label="$t('shop.name')">
            <template slot-scope="scope">
              <span>{{
                  scope.row.shop.username
                }}</span>
              <div style="font-size:10px; color:gray;">ID:
                <span>{{ scope.row.shop.user_id || scope.row.shop.shop_id }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.created_at')">
            <template slot-scope="scope">
              {{ scope.row.created_at | timeFormat }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('sub_accounts.main_account')" show-tooltip-when-overflow>
            <template slot-scope="scope">
              <strong v-if="scope.row.user" class="text-primary">{{ scope.row.user.display_name }} -
                {{ scope.row.user.username }}</strong>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.action')">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="m__watch_add_shop(scope.row)"><strong class="text-warning">
                {{ $t('sub_accounts.show_rule') }}</strong></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog :visible.sync="show_dialog.add_shop" :close-on-click-modal="false" width="700px">
      <div slot="title" style="padding:10px">
        <strong style="font-size: 14px">{{ $t('base.update') }} {{ $t('menu.sub_accounts') }} - {{
            $t('sub_accounts.set_rule')
          }}</strong>

        <br><br>

        <div style="margin-bottom: 20px">
          <strong>{{ $t('sub_accounts.select_sub_account') }}</strong>
          <div style="height: 10px"></div>
          <el-select style="width: 35%" size="mini" value="" v-model="request_user_id" filterable>
            <template v-for="item in sub_account_list">
              <el-option :value="item.request_user._id"
                         :label="`${item.request_user.display_name} - ${item.request_user.username}`"></el-option>
            </template>
          </el-select>
        </div>

        <div v-for="role in role_table" style="margin-bottom: 20px">
          <strong class="text-warning">{{ role.name }}</strong>
          <div style="margin-top: 10px">
            <div v-for="item in role.roles" style="width: 150px; display: inline-block; margin-right: 50px">
              <el-checkbox size="mini" v-model="item.checked"><span style="color: #000"> {{ item.name }}</span>
              </el-checkbox>
            </div>
          </div>
        </div>

        <el-row style="margin-top: 20px">
          <el-col :sm="12">
            <el-button type="danger" size="mini" icon="el-icon-refresh" @click="m__refresh_role_table">
              Refresh
            </el-button>
            <el-button type="success" size="mini" icon="el-icon-circle-check" @click="m__role_table_select_all">
              {{ $t('base.select_all') }}
            </el-button>
          </el-col>
          <el-col :sm="12" class="text-right">
            <el-button type="primary" size="mini" icon="el-icon-check" @click="m__update_sub_account_shop">
              {{ $t('base.save_config') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.watch_shop" :close-on-click-modal="false" width="700px">
      <div slot="title" style="padding:10px">
        <strong style="font-size: 14px">{{ $t('sub_accounts.rule_table') }}</strong>

        <br><br>

        <div style="margin-bottom: 20px">
        </div>

        <div v-for="role in role_table" style="margin-bottom: 10px">
          <strong class="text-warning">{{ role.name }}</strong>
          <div style="margin-top: 10px">
            <div v-for="item in role.roles" style="width: 150px; display: inline-block">
              <el-checkbox disabled size="mini" v-model="item.checked"><span style="color: #000"> {{ item.name }}</span>
              </el-checkbox>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {check_feature, show_expr_notification} from '../../addon/check_license'

export default {
  name: 'page__sub_account',

  data() {
    return {
      search_shop: '',
      username: '',
      shop_list: [],
      send_request_list: [],
      request_list: [],
      sub_account_list: [],
      show_dialog: {
        add_shop: false,
        watch_shop: false
      },
      loading: {},
      request_user_id: '',
      shop_id: '',
      sub_account_shop_list: [],
      sub_account_shop_request_list: [],

      role_table: [],

      role_table_template: [
        {
          code: 'marketing',
          name: 'Menu',
          roles: {
            keyword_tool: {
              name: this.$t('menu.atosa_keyword_tool'),
              checked: false
            },
            campaigns: {
              name: this.$t('menu.automatic_ads'),
              checked: false
            },
            products: {
              name: this.$t('menu.shop_products'),
              checked: false
            },
            flash_sale: {
              name: this.$t('menu.shop_flash_sale'),
              checked: false
            },
            flash_sale_shopee: {
              name: this.$t('menu.shopee_flash_sale'),
              checked: false
            },
            get_metrics: {
              name: this.$t('menu.business_insights'),
              checked: false
            },
            ads_center: {
              name: this.$t('menu.ads_insights'),
              checked: false
            },
            monthly_report: {
              name: this.$t('menu.monthly_reporting'),
              checked: false
            },
            order_center: {
              name: this.$t('menu.customer_insights'),
              checked: false
            },
          }
        },
        {
          code: 'keyword_ads',
          name: this.$t('ads.search_ads'),
          roles: {
            get_campaign: {
              name: this.$t('ads.show_campaigns'),
              checked: false
            },
            create_campaign: {
              name: this.$t('ads.create_campaigns'),
              checked: false
            },
            update_campaign: {
              name: this.$t('ads.update_campaigns'),
              checked: false
            },
            add_keyword: {
              name: this.$t('ads.add_keywords'),
              checked: false
            },
            update_keyword: {
              name: this.$t('ads.update_keywords'),
              checked: false
            },
            delete_keyword: {
              name: this.$t('ads.delete_keywords'),
              checked: false
            },
            auto_campaign: {
              name: this.$t('ads.config_auto'),
              checked: false
            },
            anti_click: {
              name: this.$t('ads.anti_click'),
              checked: false
            }
          }
        },
        {
          code: 'targeting_ads',
          name: this.$t('ads.discover_ads'),
          roles: {
            get_campaign: {
              name: this.$t('ads.show_campaigns'),
              checked: false
            },
            create_campaign: {
              name: this.$t('ads.create_campaigns'),
              checked: false
            },
            update_campaign: {
              name: this.$t('ads.update_campaigns'),
              checked: false
            },
            auto_campaign: {
              name: this.$t('ads.config_auto'),
              checked: false
            },
            anti_click: {
              name: this.$t('ads.anti_click'),
              checked: false
            }
          }
        },
        {
          code: 'sub_account',
          name: this.$t('menu.sub_accounts'),
          roles: {
            add_sub_account: {
              name: this.$t('sub_accounts.add_account'),
              checked: false
            }
          }
        }
      ],
    }
  },

  beforeRouteEnter(to, from, next) {
    if (check_feature('sub_account')) {
      next()
    } else {
      show_expr_notification()
      next('/')
    }
  },

  async beforeMount() {
    await this.m__get_sub_account_request_shop()
    await this.m__get_sub_account_shop()
    await this.m__get_shopee_shop()
    await this.m__send_request_list()
    await this.m__get_request_list()
    await this.m__get_sub_account_list()

    this.role_table = this.clone(this.role_table_template)
  },

  computed: {
    c__shopee_shop_filer_list() {
      const words = this.remove_unicode(this.search_shop)
      return this.shop_list.filter(i => i.shop_id.includes(words) || i.username.includes(words))
    }
  },

  methods: {
    async m__watch_add_shop(shop) {
      this.role_table = JSON.parse(JSON.stringify(shop.role_table))
      this.show_dialog.watch_shop = true
    },

    async m__show_add_shop_dialog(shop) {
      if (!this.check_role(shop, 'sub_account', 'add_sub_account')) {
        return
      }

      this.shop_id = shop._id

      if (shop.request_user) {
        this.request_user_id = shop.request_user._id
        this.role_table = this.clone(shop.role_table || shop.sub_role_table)

        // todo: fix missing menu roles
        const marketing_role_template = this.clone(this.role_table_template.find(i => i.code === 'marketing'))
        const marketing_role = this.role_table.find(i => i.code === 'marketing')
        if (!marketing_role) {
          this.role_table.unshift(marketing_role_template)
          this.role_table = this.clone(this.role_table)
        } else {
          // if (marketing_role.roles.length !== marketing_role_template.roles.length) {
          //
          // }
        }
        // end fix missing menu roles
      } else {
        this.request_user_id = ''
        this.role_table.forEach(i => {
          Object.keys(i.roles).forEach(key => {
            i.roles[key].checked = false
          })
        })
      }

      this.show_dialog.add_shop = true
    },

    async m__get_sub_account_request_shop() {
      const resp = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/sub_account/get_sub_account_shop_request', this.cf())
      this.sub_account_shop_request_list = resp.body.data
    },

    async m__get_sub_account_shop() {
      const resp = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/sub_account/get_sub_account_shop', this.cf())
      this.sub_account_shop_list = resp.body.data
    },

    async m__get_shopee_shop() {
      const resp = await this.$http.get(this.API.shopee_manager__get_shop + '?channel=shopee_marketing', this.cf())
      for (const shop of resp.body.data) {
        const sub_account_shop = this.sub_account_shop_list.find(i => i.shop_id === shop._id)
        if (sub_account_shop) {
          shop.is_sub_account = false
          shop.request_user = sub_account_shop.request_user
          shop.role_table = sub_account_shop.role_table
          shop.sub_account_shop_id = sub_account_shop._id
        }
      }
      this.shop_list = resp.body.data

      const resp_sub_account = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/sub_account/get_shop', this.cf())
      resp_sub_account.body.data.forEach(i => {
        i.username += ' - Shop phụ trách'
      })

      for (const shop of resp_sub_account.body.data) {
        const sub_account_shop = this.sub_account_shop_list.find(i => i.shop_id === shop._id)
        if (sub_account_shop) {
          shop.is_sub_account = true
          shop.request_user = sub_account_shop.request_user
          // shop.role_table = sub_account_shop.role_table
          shop.sub_role_table = sub_account_shop.role_table
          shop.sub_account_shop_id = sub_account_shop._id
        }
      }

      this.shop_list.push(...resp_sub_account.body.data)
    },

    async m__send_request_list() {
      const resp = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/sub_account/send_request_list', this.cf())
      this.send_request_list = resp.body.data
    },

    async m__send_request() {
      if (!this.username) {
        this.ntf_w(this.$t('required.username'))
        return
      }

      try {
        await this.$confirm(this.$t('base.confirm_action'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })

        const resp = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/sub_account/send_request', {username: this.username}, this.cf())
        await this.m__send_request_list()
        this.username = ''
        this.ntf_s(resp.body.message)
      } catch (e) {
        if (!['cancel', 'close'].includes(e)) {
          this.ntf_w(e)
        }
      }
    },

    async m__get_request_list() {
      const resp = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/sub_account/get_request_list', this.cf())
      this.request_list = resp.body.data
    },

    async m__change_request_status(request_id, status) {
      try {
        await this.$confirm(this.$t('base.confirm_action'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
        const resp = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/sub_account/change_request_status', {
          request_id,
          status
        }, this.cf())
        await this.m__get_request_list()
        this.ntf_s(resp.body.message)
      } catch (e) {
        if (!['cancel', 'close'].includes(e)) {
          this.ntf_w(e)
        }
      }
    },

    async m__delete_sub_account_request(request_id) {
      try {
        await this.$confirm(this.$t('base.confirm_action'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
        const resp = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/sub_account/delete_sub_account_request', {
          request_id
        }, this.cf())
        await this.m__get_sub_account_request_shop()
        await this.m__get_sub_account_shop()
        await this.m__get_shopee_shop()
        await this.m__send_request_list()
        await this.m__get_request_list()
        await this.m__get_sub_account_list()
        this.ntf_s(resp.body.message)
      } catch (e) {
        if (!['cancel', 'close'].includes(e)) {
          this.ntf_w(e)
        }
      }
    },

    async m__get_sub_account_list() {
      const resp = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/sub_account/get_sub_account_list', this.cf())
      this.sub_account_list = resp.body.data
    },

    m__refresh_role_table() {
      for (const item of this.role_table) {
        for (const key of Object.keys(item.roles)) {
          item.roles[key].checked = false
        }
      }
    },

    m__role_table_select_all() {
      for (const item of this.role_table) {
        for (const key of Object.keys(item.roles)) {
          item.roles[key].checked = true
        }
      }
    },

    async m__update_sub_account_shop() {
      if (!this.request_user_id) {
        this.ntf_w(this.$t('required.select_sub_account'))
        return
      }

      let count = 0
      for (const item of this.role_table) {
        count += Object.keys(item.roles).reduce((total, key) => {
          if (item.roles[key].checked) {
            total++
          }
          return total
        }, 0)
      }

      if (count === 0) {
        this.ntf_w(this.$t('required.set_rule_for_sub_account'))
        return
      }

      try {
        await this.$confirm(this.$t('base.confirm_action'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })

        const resp = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/sub_account/update_sub_account_shop', {
          shop_id: this.shop_id,
          request_user_id: this.request_user_id,
          role_table: this.role_table
        }, this.cf())

        await this.m__get_sub_account_shop()
        await this.m__get_shopee_shop()

        this.ntf_s(resp.body.message)
        this.show_dialog.add_shop = false
      } catch (e) {
        if (!['cancel', 'close'].includes(e)) {
          this.ntf_w(e)
        }
      }
    },

    async m__delete_sub_account_shop(_id) {
      try {
        await this.$confirm(this.$t('base.confirm_delete_x', {x: this.$t('base.config')}), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
        const resp = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/sub_account/delete_sub_account_shop', {
          sub_account_shop_id: _id
        }, this.cf())
        await this.m__get_sub_account_shop()
        await this.m__get_shopee_shop()
        this.ntf_s(resp.body.message)
      } catch (e) {
        if (!['cancel', 'close'].includes(e)) {
          this.ntf_w(e)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/sub_account/index.vue